import React, { useEffect, useState, useRef } from 'react'
import { Row, Col, FormGroup, Label } from 'reactstrap'
import _ from 'lodash'

import LanguageSelector from 'components/LanguageSelector'

const MultilingualInput = ({
  label,
  value,
  height,
  onChange,
  selectedLanguage,
  isDutchAsRomanian
}) => {
  const editorRef = useRef()
  const testEditorRef = useRef()
  const [editorLoaded, setEditorLoaded] = useState(false)
  const { CKEditor, CustomEditor } = editorRef.current || {}
  const [buttonLang, updateButtonLang] = useState('')

  useEffect(() => {
    updateButtonLang(selectedLanguage)
  }, [selectedLanguage])

  useEffect(() => {
    if (!_.isEmpty(selectedLanguage)) {
      editorRef.current = {
        CKEditor: require('@ckeditor/ckeditor5-react').CKEditor,
        CustomEditor: require('ckeditor5-custom-build/build/ckeditor'),
      }
      if (!_.isEmpty(selectedLanguage) && selectedLanguage !== 'en') {
        require(`ckeditor5-custom-build/build/translations/${selectedLanguage}`)
      }
      setEditorLoaded(true)
    }
  }, [selectedLanguage])

  const langList = ['en', 'de', 'nl', 'it']

  const updateContent = val => {
    let tmpValue = _.cloneDeep(value)
    tmpValue[buttonLang] = val
    return onChange(tmpValue)
  }

  return (
    <FormGroup onMouseOut={() => updateContent(testEditorRef.current.editor.getData())} >
      <style>
        {`
          .ck-dropdown__panel {
            max-height: 200px !important;
            overflow-y: auto !important;
          }
          .ck-fontsize-option .ck-button__label {
            font-size: 1rem !important;
          }
        `}
      </style>
      <Row
        className='mb-2 d-flex align-items-center'
        style={{ justifyContent: label ? "space-between" : "flex-end" }} >
        {
          label && <Col>
            <Label className='mb-0'>{label}</Label>
          </Col>
        }
        <LanguageSelector
          currentLang={buttonLang}
          updateLang={updateButtonLang}
          isDutchAsRomanian={isDutchAsRomanian}
        />
      </Row>
      {
        buttonLang && (
          <>
            {
              langList.map(item => {
                if (buttonLang === item) {
                  return editorLoaded && (
                    <CKEditor
                      key={item}
                      ref={testEditorRef}
                      editor={CustomEditor.ClassicEditor}
                      onReady={editor => {
                        editor.editing.view.change((writer) => {
                          writer.setStyle('height', height || '400px', editor.editing.view.document.getRoot())
                        })
                      }}
                      data={value ? value[item] : ''}
                      config={{
                        toolbar: [
                          'heading',
                          '|',
                          'sourceEditing',
                          '|',
                          'fontSize', 'bold', 'italic', 'fontColor', 'fontBackgroundColor',
                          '|',
                          'link',
                          'bulletedList', 'numberedList',
                          '|',
                          'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                          '|',
                          'imageUpload', 'blockQuote',
                          'insertTable', 'mediaEmbed',
                          '|',
                          'undo', 'redo'
                        ],
                        fontSize: {
                          options: [10, 12, 14, 'default', 18, 20, 22, 24, 26, 28, 30],
                          supportAllValues: true
                        },
                        heading: {
                          options: [
                            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                            { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                            { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                            { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' },
                            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                            { model: 'span', view: 'div', title: 'Span' }
                          ]
                        },
                        link: {
                          decorators: {
                            openInNewTab: {
                              mode: 'manual',
                              label: 'Open in a new tab',
                              attributes: {
                                target: '_blank',
                                rel: 'noopener noreferrer'
                              }
                            }
                          }
                        },
                        fontSize: { options: _.filter(Array.from(Array(121).keys()), item => item >= 8) }
                      }}
                    />
                  )
                }
              })
            }
          </>
        )
      }
    </FormGroup>
  )
}

export default MultilingualInput
